import { Link } from "react-router-dom";
import { JOYSPOT_QUIZ_URL } from "@/lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-[2] bg-[#FAFAF8] border-t border-[#E7E5E4]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-[43px] md:pt-[52px] pb-20 md:pb-24">
        {/* Logo and tagline */}
        <div className="mb-16">
          <Link to="/" className="inline-block mb-6">
            <span className="font-display text-3xl tracking-tight text-[#1C1917]">
              Blueprint<span className="text-[#FF5A4F]">4</span>Joy
              <span className="text-[#159E9A] align-super text-[12px] ml-1">®</span>
            </span>
          </Link>
          <p className="text-base text-[#57534E] max-w-md leading-relaxed">
            See what's true. Remember what matters. Build from there.
          </p>
        </div>

        {/* Navigation columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-12 mb-[53px]">
          <div>
            <h3 className="font-display text-lg text-[#1C1917] mb-6">
              Explore
            </h3>
            <ul className="space-y-4">
              <li><Link to="/" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">About</Link></li>
              <li><Link to="/books" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">Books</Link></li>
              <li><Link to="/this-curious-life" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">This Curious Life</Link></li>
              <li><Link to="/speaking" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">Speaking</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-display text-lg text-[#1C1917] mb-6">
              Work With Me
            </h3>
            <ul className="space-y-4">
              <li><Link to="/work-with-me" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">Vision Book Workshop</Link></li>
              <li><Link to="/work-with-me/spark-sessions" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">Spark Sessions</Link></li>
              <li><Link to="/work-with-me" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">Consistency Corner</Link></li>
              <li><Link to="/believing-happy" data-testid="footer-link-believing-happy" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">Believing Happy</Link></li>
              <li><Link to="/work-with-me" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">Group Coaching</Link></li>
              <li><Link to="/work-with-me" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">1:1 Coaching</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="font-display text-lg text-[#1C1917] mb-6">
              Start Here
            </h3>
            <ul className="space-y-4">
              <li><a href={JOYSPOT_QUIZ_URL} data-testid="footer-link-joyspot" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">Find Your JOYspot™</a></li>
              <li><Link to="/work-with-me" className="text-[#57534E] hover:text-[#FF5A4F] transition-colors">Vision Book Workshop</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div className="border-t border-[#E7E5E4]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-[26px] pb-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-sm text-[#57534E]">
            <p className="mb-2 md:mb-0">© {new Date().getFullYear()} Blueprint4Joy®. All rights reserved. By Lara Parrish.</p>
          </div>
          <div className="flex gap-6 text-sm">
            <Link to="/privacy" className="text-[#57534E] hover:text-[#159E9A] transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-[#57534E] hover:text-[#159E9A] transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
